export default String.raw`
<div class="cart thank-you-content">
    {% if cart.PlacedOrder.CreditLimit and cart.PlacedOrder.CreditLimit.Active and cart.OrderTotalValue > cart.PlacedOrder.CreditLimit.Left and cart.PlacedOrder.CreditLimit.Status == 1 -%}
        <div class="cart__info-bar warning-bar">
            {{ cart.PlacedOrder.CreditLimit.StatusText }}
        </div>
    {% endif -%}
    {% if cart.PlacedOrder.CreditLimit and cart.PlacedOrder.CreditLimit.Active -%}
        <input type="hidden" name="updated-credit-limit-left" value="{{cart.PlacedOrder.CreditLimit.Left}} {{customer.CurrencyExt.Symbol|H}}">
    {% endif -%}
    {% if cart.PlacedOrder.ExternalPayment.Form -%}
        <script>
            if(typeof gtag != 'undefined'){
                $.get('', {__collection:'cart.PlacedOrder.Products'},function(res){
                    var products = res.collection;
                    var productsForGA4DataLayer = [];
                    var totalValue = 0;
                    for(var i=0; i<products.length; i++){
                        var productGA4DL = { item_id: products[i].Id.toString(), item_name: products[i].NameNoHtml, price: products[i].TotalPrice, quantity: products[i].Quantity };
                        productsForGA4DataLayer.push(productGA4DL);
                        totalValue = totalValue + (products[i].TotalPrice * products[i].Quantity);
                    }
                    gtag("event", "begin_checkout", {
                        currency: __currCode,
                        value: totalValue,
                        items: productsForGA4DataLayer
                    });
                });
            }
        </script>
        <div class="cart__redirect">
            <div class="cart__redirect-title">{{ translations.PaymentRedirecting }}</div>
            <form class="form-js cart__redirect-form" method="{% if cart.PlacedOrder.ExternalPayment.GET -%}get{% else -%}post{% endif -%}" action="{{ cart.PlacedOrder.ExternalPayment.Url }}">
                <div class="cart__redirect-wrapper">
                    <svg class="cart__redirect-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#wallet-{{settings.iconStyle}}"></use>
                    </svg>
                    <div>
                        <div class="cart__redirect-text">
                            {{ translations.SelectedPayment }}:
                            <span>{{ cart.SelectedDelivery.Payment.Name }}</span>
                        </div>
                        {% if cart.SelectedDelivery.Payment.Channel -%}
                            <div class="cart__redirect-text">
                                {{ translations.SelectedChannel }}:
                                <span>{{ cart.SelectedDelivery.Payment.Channel.Name }}</span>
                            </div>
                        {% endif -%}
                    </div>
                </div>
                <div class="cart__redirect-info">
                    {% case cart.SelectedDelivery.Payment.MethodType -%}
                        {% when '2' -%}
                            {{ translations.GoToPaymentService }}
                        {% when '3' -%}
                            {{ translations.GoToInstallmentService }}
                        {% when '4' -%}
                            {{ translations.GoToLeasingService }}
                    {% endcase -%}
                </div>
                {% for field in cart.PlacedOrder.ExternalPayment.Fields -%}
                    <input type="hidden" name="{{ field.Name }}" value="{{ field.Value }}">
                {% endfor -%}
                {% for consent in cart.PlacedOrder.ExternalPayment.Consents -%}
                    <div class="cart__tos-consent tos-container-js {% if consent.Statement -%} statement-js {% endif -%}">
                        {% if consent.Statement -%}
                            <input type="hidden" name="{{ consent.FieldName }}" value="{{ consent.FieldValue }}">
                            <div>{{ consent.Text }}</div>
                        {% else -%}
                            <label tabindex="0" role="checkbox" aria-checked="false" class="cart__tos-label tos-js">
                                <input type="checkbox" name="{{ consent.FieldName }}" value="{{ consent.FieldValue }}" {% if consent.Required -%} required {% endif -%} >
                                <div class="cart__tos-checkbox">
                                    <svg>
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                    </svg>
                                </div>
                                <div class="cart__tos-consent-label">
                                    {% if consent.Required -%}<span class="cart__tos-required">*</span> {% endif -%}{{ consent.Text }}
                                </div>
                                {% if consent.Required -%}
                                    <div class="cart__tos-error validation-info-js validation-required-js hidden-js">{{ translations.RequiredField }}</div>
                                {% endif -%}
                            </label>
                        {% endif -%}
                    </div>
                {% endfor %}
                <button class="primary-action-button cart__redirect-btn external-payment-js">
                    {% case cart.SelectedDelivery.Payment.MethodType -%}
                        {% when '2' -%}
                            {{ translations.ProceedToPayment }}
                        {% when '3' -%}
                            {{ translations.SubmitRequest }}
                        {% when '4' -%}
                        {{ translations.SubmitRequest }}
                    {% endcase -%}
                    <svg class="right-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#external-link-square-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
                {% if cart.PlacedOrder.Source == 10 -%}
                    <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 99999; background: #eff2f7; display: flex; justify-content: center; align-items: center">
                        <div style="color: #47525e; font-size: 23px; text-align: center; padding: 20px">
                            {{translations.OnlinePaymentRedirectInfo}}
                        </div>
                    </div>
                    <script>
                        setTimeout(function(){
                            $('.external-payment-js').trigger('click');
                        }, 1);
                    </script>
                {% endif -%}
            </form>
        </div>
    {% else -%}
        {% if cart.PlacedOrder.Source == 10 -%}
            <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 99999; background: #eff2f7; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <div style="color: #934346; font-size: 30px; text-align: center; padding: 20px;">
                    {{translations.Thx}}!
                </div>
                <div style="color: #47525e; font-size: 23px; text-align: center; padding: 20px;">
                    {% if cart.PlacedOrder.ExternalPayment.Success -%}
                        {{ translations.OnlineTransactionCorrect }}
                    {% else -%}
                        <div>{{ translations.OnlineTransactionIncorrect }}</div>
                        <div>{{ cart.PlacedOrder.ExternalPayment.Message }}</div>
                    {% endif -%}
                </div>
                <div style="color: #47525e; font-size: 23px; text-align: center; padding: 20px;">
                    {{translations.BackToAppInfo}}
                </div>
            </div>
        {% else -%}
			<script>
                (function(){
                    var i,dl={{ page.GtmDL }};
                    for(i in dl) window.dataLayer.push(dl[i]);
					var i,dl={{ page.Ga4DL }};
                    for(i in dl) gtag(dl[i].eventType, dl[i].event, dl[i].data);
                })();
            </script>
            {% if cart.SelectedDelivery.Payment.MethodType != 1 and cart.PlacedOrder.ExternalPayment.Success == false -%}
                {% assign externalPaymentError = true -%}
            {% endif -%}
            <div class="thank-you">
                <div class="thank-you__title">
                    {% if externalPaymentError -%}
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-circle-{{settings.iconStyle}}"></use>
                        </svg>
                        {{translations.OnlinePaymentError}}
                    {% else -%}
                        {{ translations.Thanks }}
                    {% endif -%}
                </div>
            </div>
            {% if cart.PlacedOrder.ConfirmationRequired -%}
                <div class="cart__info-bar warning-bar">
                    {{ translations.ConfirmationEmailSent }}
                </div>
            {% endif -%}
            {% if cart.SelectedDelivery.Payment.MethodType != 1 and cart.PlacedOrder.ExternalPayment.Success -%}
                <div class="cart__info-bar success-bar">
                    {{ translations.OnlineTransactionCorrect }}
                </div>
            {% endif -%}
            <div class="thank-you__text">
                {% if externalPaymentError -%}
                    {{translations.OnlinePaymentInfo}}
                    <a href="mailto:{{config.Shop.Contact.Email}}">{{config.Shop.Contact.Email}}</a>
                {% else -%}
                    {% capture customerEmail -%}<span>{{ cart.Customer.Email }}</span>{% endcapture -%}
                    {{ translations.OrderEmailSent | Format: customerEmail }}
                {% endif -%}
            </div>
            {% include 'partials/common/date-format.html' -%}
            {% if cart.SelectedDelivery.Payment.MethodType != 1 and cart.PlacedOrder.ExternalPayment.Success == false -%}
            {% else -%}
                <script>
                    var date = new Date();
                    date.setTime(date.getTime() + (360*24*60*60*1000));
                    var expires = "expires="+date.toUTCString();
                    document.cookie = "lastCartId=-1; " + expires + "; SameSite=Lax; path=/";
                </script>
            {% endif -%}
            <div class="thank-you__box">
                <div class="thank-you__box-column">
                    <div class="thank-you__box-text">
                        {{ translations.NumberOfOrder }}:
                        <span>{{ cart.PlacedOrder.Id }}</span>
                    </div>
                    <div class="thank-you__box-text">
                        {{ translations.OrderDate }}:
                        <span>{{ cart.PlacedOrder.Date | Date:dateFormat }}</span>
                    </div>
                    {% if externalPaymentError -%}
                        {% if cart.PlacedOrder.ExternalPayment.Unavailable -%}
                            <div class="thank-you__box-btn message">{{ cart.PlacedOrder.ExternalPayment.Message }}</div>
                        {% else -%}
                            <div class="form-js">
                                <input type="hidden" name="__action" value="Order/RestorePayment">
                                <input type="hidden" name="id" value="{{ cart.PlacedOrder.Id }}">
                                <input type="hidden" name="hash" value="{{ cart.PlacedOrder.Hash }}">
                                <button class="primary-action-button thank-you__box-btn post-js" data-url="{{page.BaseHref}}{{config.DefinedPages.Order.Url}}">
                                    {{ translations.RestorePayment }}
                                    <svg class="right-icon">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#sync-{{settings.iconStyle}}"></use>
                                    </svg>
                                </button>
                            </div>
                        {% endif -%}
                    {% else -%}
                        <a class="primary-action-button thank-you__box-btn" href="{{page.BaseHref}}{{config.DefinedPages.CustomerProfile.Url}}?orderId={{cart.PlacedOrder.Id}}&orderHash={{cart.PlacedOrder.Hash}}">{{ translations.SeeOrderDetails }}</a>
                    {% endif -%}
                </div>
                {% if settings.loyaltyProgram == "yes" -%}
                    {% if cart.Coupon == null -%}
                        {% if cart.Points or cart.PointsForValue != null or cart.PointsPaid != null -%}
                            {% assign gainedPoints = cart.Points -%}
                            <div class="thank-you__box-column">
                                <div class="cart__loyalty-info">
                                    {% capture points -%} <strong>{{ cart.Points | ToString }}</strong> {% endcapture -%}
                                    <svg width="24px" height="24px">
                                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#award-{{settings.iconStyle}}'></use>
                                    </svg>
                                    <span>
                                        {% if usr.Authenticated -%}
                                            {% if cart.PointsPaid != null -%}
                                                <p>{{ translations.PointsUsed }}: <strong>{{ cart.PointsPaid }} {{ translations.PointsShortcut }}</strong>.</p>
                                            {% endif -%}
                                            {% if gainedPoints != null -%}
                                                <p>{{ translations.PointsGained }}: <strong>{{ gainedPoints }} {{ translations.PointsShortcut }}</strong>.</p>
                                            {% endif -%}
                                            <p>{{ translations.CurrentPoints }}: <strong>{{ customer.Points }} {{ translations.PointsShortcut }}</strong>.</p>
                                        {% else -%}
                                            <p>{{ translations.LoyaltyInfoForNotLogged | Format: points }}</p>
                                        {% endif -%}
                                    </span>
                                </div>
                            </div>
                        {% endif -%}
                    {% endif -%}
                {% endif -%}
            </div>
            <div class="thank-you__column-wrapper">
                <div class="thank-you__column">
                    <div class="thank-you__column-title">{{ translations.Summary }}</div>
                    <div class="thank-you__column-text">
                        {{ translations.OrdStatus }}:
                        <span>{{ cart.PlacedOrder.StatusText }}</span>
                    </div>
                    <div class="thank-you__column-text">
                        {{ translations.ItemsQuantity }}:
                        <span>{{ cart.PlacedOrder.Products | Size }}</span>
                    </div>
                    {% if cart.Discount > 0 and settings.discountsPresentationInOrderSummary == 'yes' -%}
                        <div class="thank-you__column-text">
                            {{ translations.Value }}
                            {% if cart.SubtotalPrices -%}
                                {{ translations.Netto | Downcase }}
                            {% else -%}
                                {{ translations.Brutto | Downcase }}
                            {% endif -%}
                            {{ translations.BeforeDiscount | Downcase }}:
                            <span>{{ cart.ProductsValueBeforeDiscount | ToPrice }} {{ cart.CurrencyExt }}</span>
                        </div>
                        <div class="thank-you__column-text">
                            {{ translations.Discount }}:
                            <span>{{ cart.Discount | Normalize }} %</span>
                        </div>
                    {% endif -%}
                    {% if cart.NotDeterminedDeliveryCost == false and cart.SelectedDelivery.NotDeterminedDeliveryCost == false -%}
                        <div class="thank-you__column-text">
                            {{ translations.DelivCost }}:
                            <span>{{ cart.SelectedDelivery.TotalValue | ToPrice }} {{ cart.CurrencyExt }}</span>
                        </div>
                    {% endif -%}
                    {% if cart.SelectedDelivery.Payment.TotalValue != null and cart.NotDeterminedDeliveryCost == false and cart.SelectedDelivery.NotDeterminedDeliveryCost == false -%}
                        <div class="thank-you__column-text">
                            {{ translations.PaymentCost }}:
                            <span>{{ cart.SelectedDelivery.Payment.TotalValue | ToPrice }} {{ cart.CurrencyExt }}</span>
                        </div>
                    {% endif -%}
                    {% if cart.TotalDepositValue > 0 -%}
                        <div class="thank-you__column-text">
                            {{ translations.Com_Deposit }}:
                            <span>{{ cart.TotalDepositValue | ToPrice: config.DecimalPlacesPrice }} {{ cart.CurrencyExt }}</span>
                        </div>
                    {% endif -%}
                    <div class="thank-you__column-text">
                        {% if config.ENTERPRISE or cart.SubtotalPrices -%}
                            {{ translations.VatValue }}:
                        {% else -%}
                            {{ translations.VatIncluded }}:
                        {% endif -%}
                        <span>{{ cart.VATValue | ToPrice }} {{ cart.CurrencyExt }}</span>
                    </div>
                    {% if config.ENTERPRISE -%}
                        <div class="thank-you__column-text">
                            {{ translations.Value }}
                            {{ translations.Netto | Downcase }}:
                            <span>{{ cart.ProductsSubtotalValue | ToPrice }} {{ cart.CurrencyExt }}</span>
                        </div>
                        <div class="thank-you__column-text">
                            {{ translations.Value }}
                            {{ translations.Brutto | Downcase }}:
                            <span>{{ cart.ProductsTotalValue | ToPrice }} {{ cart.CurrencyExt }}</span>
                        </div>
                    {% else -%}
                        <div class="thank-you__column-text">
                            {{ translations.Value }}
                            {% if cart.SubtotalPrices -%}
                                {{ translations.Netto | Downcase }}:
                            {% else -%}
                                {{ translations.Brutto | Downcase }}:
                            {% endif -%}
                            <span>
                                {% if cart.SubtotalPrices -%}
                                    {{ cart.ProductsSubtotalValue | ToPrice }}
                                {% else -%}
                                    {{ cart.ProductsTotalValue | ToPrice }}
                                {% endif -%}
                                {{ cart.CurrencyExt }}
                            </span>
                        </div>
                    {% endif -%}
                    <div class="thank-you__column-text">
                        {{ translations.AmountDue }}:
                        <span>{{ cart.OrderTotalValue | ToPrice }} {{ cart.CurrencyExt }}</span>
                    </div>
                </div>
                <div class="thank-you__column">
                    <div class="thank-you__column-title">{{ translations.MyData }}</div>
                    {% if settings.buyerData == "yes" and cart.Customer.Buyer -%}
                        {% assign myDataAddress = cart.Customer.Buyer -%}
                    {% else -%}
                        {% assign myDataAddress = cart.Customer.DeliveryAddress -%}
                    {% endif -%}
                    <div class="thank-you__column-text">
                        {{ translations.BuyInShopAs }}:
                        <span>
                            {% if cart.Customer.Company and cart.Customer.Invoice -%}
                                {{ translations.Company }}
                            {% else -%}
                                {{ translations.PrivatePerson }}
                            {% endif -%}
                        </span>
                    </div>
                    <div class="thank-you__column-text">
                        {{ translations.SalesDocument }}:
                        <span>
                            {% if cart.Customer.Invoice -%}
                                {{ translations.Invoice }}
                            {% else -%}
                                {{ translations.Recipe }}
                            {% endif -%}
                        </span>
                    </div>
                    <div class="thank-you__column-text">
                        {{ translations.Email }}:
                        <span>{{ cart.Customer.Email }}</span>
                    </div>
                    <div class="thank-you__column-text">
                        {{ translations.Country }}:
                        <span>{{ config.Countries[myDataAddress.Country].Name }}</span>
                    </div>
                    {% if cart.Customer.TIN != '' -%}
                        <div class="thank-you__column-text">
                            {{ translations.TIN }}:
                            <span>
                                {% if config.ENTERPRISE and cart.Customer.VATEU != '' -%}
                                    {{cart.Customer.VATEU}}
                                {% endif -%}

                                {{cart.Customer.TIN}}
                            </span>
                        </div>
                    {% endif -%}
                    <div class="thank-you__column-text">
                        {% if customer.Company == false or cart.Customer.Invoice == false -%}
                            {{ translations.NameAndSurname }}:
                        {% else -%}
                            {{ translations.CompanyName }}:
                        {% endif -%}
                        <span>{{myDataAddress.Name}} {{myDataAddress.Name2}}</span>
                    </div>
                    <div class="thank-you__column-text">
                        {{ translations.Street }}:
                        <span>
                            {{myDataAddress.Street}}
                            {{myDataAddress.StreetNo}}{% if myDataAddress.UnitNo != ''-%}/{{myDataAddress.UnitNo}}{% endif -%}
                        </span>
                    </div>
                    <div class="thank-you__column-text">
                        {{ translations.City }}:
                        <span>{{myDataAddress.ZipCode}} {{myDataAddress.City}}</span>
                    </div>
                    {% if myDataAddress.PhoneNo != '' -%}
                        <div class="thank-you__column-text">
                            {{ translations.PhoneNumber }}:
                            <span>{{ myDataAddress.PhoneNo }}</span>
                        </div>
                    {% endif -%}
                </div>
                <div class="thank-you__column">
                    <div class="thank-you__column-title">{{ translations.DeliveryMethodAndAddress }}</div>
                    <div class="thank-you__column-text">
                        {{ translations.MethodOfDelivery }}:
                        <span>{{ cart.SelectedDelivery.Name }}</span>
                    </div>
                    {% if cart.SelectedDelivery.CollectionPoint -%}
                        <div class="thank-you__column-text">
                            {% if cart.SelectedDelivery.CollectionPointTypeId == 2 -%}
                                {{ translations.ChoosenInpostMachine }}:
                            {% else -%}
                                {{ translations.ChoosenCollectionPoint }}:
                            {% endif -%}
                            <span>
                                {% assign collectionPoint = cart.SelectedDelivery.CollectionPoint -%}
                                {% assign collectionName = collectionPoint.Address | Split:',' | Last | Split:'(' | First -%}
                                {% if collectionName == '' or collectionName == ' ' or collectionName == '  ' -%}
                                    {% assign collectionName = collectionPoint.Address | Split:'(' | Last | Remove:')' -%}
                                    {% capture collectionName -%}{{collectionName}}{% endcapture -%}
                                {% endif -%}
                                <br>
                                {{collectionName}}
                                <br>
                                {{collectionPoint.Street}} {{collectionPoint.StreetNo}}{% if collectionPoint.UnitNo != null and collectionPoint.UnitNo != '' -%}/{{collectionPoint.UnitNo}}{% endif -%}
                                <br>
                                {{collectionPoint.ZipCode}} {{collectionPoint.City}}
                                <br>
                                {{collectionPoint.Country}}
                            </span>
                        </div>
                    {% else -%}
                        {% assign deliveryAddress = cart.Customer.DeliveryAddress -%}
                        <div class="thank-you__column-text">
                            {% if customer.Company == false or cart.Customer.Invoice == false -%}
                                {{ translations.NameAndSurname }}:
                            {% else -%}
                                {{ translations.CompanyName }}:
                            {% endif -%}
                            <span>{{deliveryAddress.Name}} {{deliveryAddress.Name2}}</span>
                        </div>
                        <div class="thank-you__column-text">
                            {{ translations.Street }}:
                            <span>
                                {{deliveryAddress.Street}}
                                {{deliveryAddress.StreetNo}}{% if deliveryAddress.UnitNo != ''-%}/{{deliveryAddress.UnitNo}}{% endif -%}
                            </span>
                        </div>
                        <div class="thank-you__column-text">
                            {{ translations.City }}:
                            <span>{{deliveryAddress.ZipCode}} {{deliveryAddress.City}}</span>
                        </div>
                        {% if deliveryAddress.PhoneNo != '' -%}
                            <div class="thank-you__column-text">
                                {{ translations.PhoneNumber }}:
                                <span>{{ deliveryAddress.PhoneNo }}</span>
                            </div>
                        {% endif -%}
                    {% endif -%}
                    {% if cart.SelectedDelivery.SelectedDate -%}
                        <div class="thank-you__column-text">
                            {{ translations.ScheduledDeliveryDate }}:
                            <span>
                                {{ cart.SelectedDelivery.SelectedDate | Date: dateFormat }}
                                {% if settings.deliveryDateType == "date-and-time" -%}
                                    {{ cart.SelectedDelivery.SelectedDate | Date:'HH:mm' }}
                                {% endif -%}
                            </span>
                        </div>
                    {% endif -%}
                </div>
                <div class="thank-you__column">
                    <div class="thank-you__column-title">{{ translations.MethodOfPayment }}</div>
                    <div class="thank-you__column-text">
                        {{ translations.MethodOfPayment }}:
                        <span>{{ cart.SelectedDelivery.Payment.Name }}</span>
                    </div>
                    {% if cart.SelectedDelivery.Payment.Channel -%}
                        <div class="thank-you__column-text">
                            {{ translations.ChannelOfPayment }}:
                            <span>{{ cart.SelectedDelivery.Payment.Channel.Name }}</span>
                        </div>
                    {% endif -%}
                </div>
            </div>
            <div class="thank-you__section">
                <div class="thank-you__section-title">{{ translations.Agreements }}</div>
                {% for consent in cart.PlacedOrder.Consents -%}
                    {% if consent.Checked -%}
                        <div class="thank-you__section-text">{{ consent.Text }}</div>
                    {% endif -%}
                {% endfor -%}
            </div>
            {% if cart.Note != "" -%}
                <div class="thank-you__section">
                    <div class="thank-you__section-title">{{translations.Notes}}</div>
                    <div class="thank-you__section-text">{{ cart.Note }}</div>
                </div>
            {% endif -%}
            <div class="thank-you__divider"></div>  
            {% include 'edrone/order.html' %}
        {% endif -%}
    {% endif -%}
    {% include 'partials/cart/lastpagescripts.html' %}
    <script>
        !function(){
            var i,dl={{ page.GtmDL }};
            for(i in dl) window.dataLayer.push(dl[i]);

            var fbDLC={{ page.FbDL }};
            fbDLC.forEach(function(z){fbq.push(z);});

            if(typeof snaptr !== 'undefined'){
                var snapchatDL={{ page.SnapchatDL }}
                for (let i = 0; i < snapchatDL.length; i++) {
                    setTimeout(() => {
                        const e = snapchatDL[i];
                        if (e?.[2]) {
                            e[2].client_dedup_id = e?.[1] + '_' + new Date().getTime();
                        }
     					snaptr(e?.[0], e?.[1], e?.[2]);
                    }, i * 500);
                }
     		}

            if(typeof ttq !== 'undefined'){
                for (let i = 0; i < tiktokDL.length; i++) {
                    setTimeout(() => {
                        const e = tiktokDL[i];
                        ttq.track(e?.[0], e?.[1], e?.[2]);
                    }, i * 500);
                }
            }
        }();
    </script>
</div>
`